import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import {
  Form,
  Segment,
  Table,
  Header,
  Select,
  Input,
  Icon,
  Button,
  Message,
  Checkbox,
} from 'semantic-ui-react';
import { get, isEmpty } from 'lodash';
import { graphql } from 'react-apollo';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Validator from 'validatorjs';
import { NumericFormat } from 'react-number-format';
import LoadingDataEnhancer from '../../containers/LoadingData';
import auctionLocationsQuery from '../../graphql/auctionLocationsQuery';
import { utcMoment } from '../../utilities/dateUtils';
import checkCurrentEnrollmentOfDealerQuery from '../../graphql/checkCurrentEnrollmentOfDealerQuery';
import dealerInformationQuery from '../../graphql/dealerInformationQuery';
import client from '../../apollo';

class AutoPsiForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealerNumber: '',
      dealerNo: '',
      requestType: null,
      dealername: '',
      contactname: '',
      contactemail: '',
      contactphone: '',
      product1: '',
      product2: null,
      cascade: false,
      flatrate1: null,
      flatrate2: null,
      purchaseChannel1: ['In-Lane', 'Simulcast'],
      purchaseChannel2: [],
      location1: [],
      location2: [],
      lpiprice1: 0,
      psimileage1: '',
      startDate1: null,
      startDate2: null,
      openReviewModal: false,
      showAdditionalPriceMessage: false,
      showflatrate1PriceField: false,
      errors: {},
      modify: false,
      cancel: false,
      description: null,
      searched: false,
      customMileage1: null,
      customMileage2: null,
      lpiPrice: null,
      endDate1: null,
      endDate2: null,
      psiprice1: 0,
      lpimileage: 0,
      excludeCloseSale: false,
      createNewEnrollment: false,
    };
  }

  handleCheckBoxChange = (field1, field2) => (event, data) => {
    this.setState({ [field1]: data.checked, [field2]: false });
  };

  onSearchSubmitHandler = () => {
    this.setState({
      description: null,
      searched: true,
      createNewEnrollment: true,
      errors: {},
    });
    this.setState({
      dealerNumber: '',
      dealername: '',
      contactname: '',
      contactemail: '',
      contactphone: '',
      cascade: false,
      product1: null,
      purchaseChannel1: ['In-Lane', 'Simulcast'],
      location1: [],
      location2: [],
      psimileage1: '',
      lpiprice1: 0,
      psiprice1: 0,
      lpimileage: 0,
      startDate1: '',
      endDate1: '',
      showLocation2Warning: false,
    });
    const { dealerNo } = this.state;
    client
      .query({
        query: checkCurrentEnrollmentOfDealerQuery,
        variables: { dealerNumber: dealerNo },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        const {
          checkCurrentEnrollmentOfDealer: { description },
        } = data;
        if (description !== null) {
          this.setState({ createNewEnrollment: false });
          const removedCharData = description.replace(/=>/g, ':');
          const finalData = JSON.parse(removedCharData);
          this.setState({ description });
          if (description !== null) {
            const dealernumber = finalData.dealerNumber;
            const dealername = finalData.dealerName;
            const contactname = finalData.contactName;
            const contactemail = finalData.contactEmail;
            const contactphone = finalData.contactPhoneNumber;
            const { excludeCloseSale } = finalData;
            const products = Object.keys(finalData.products);
            const { cascade } = finalData;
            const product1 = products[0];
            const product2 = products[1];
            const product = finalData.products;
            const location1 = product[product1].auctionIds;
            const psimileage1 = product[product1].mileage;
            const lpimileage1 = product[product1].LPImileage;
            const lpiprice1 = product[product1].LPIprice;
            const startDate1 = product[product1].startDate;
            const endDate1 = product[product1].endDate;
            const purchaseChannel1 = product[product1].channel;
            const psiprice1 = product[product1].PSIprice;
            if (product2 !== undefined) {
              const location2 = product[product2].auctionIds;
              const startDate2 = product[product2].startDate;
              const endDate2 = product[product2].endDate;
              const purchaseChannel2 = product[product2].channel;
              this.setState({
                purchaseChannel2,
                location2,
                startDate2,
                endDate2,
              });
            }
            this.setState({
              dealerNumber: dealernumber,
              dealername,
              contactname,
              contactemail,
              contactphone,
              product1,
              product2,
              cascade,
              purchaseChannel1,
              location1,
              psimileage1:
                psimileage1 === 0 || psimileage1 === '0' ? null : psimileage1,
              lpimileage: lpimileage1,
              lpiprice1,
              startDate1,
              endDate1,
              psiprice1,
              flatrate1: psiprice1,
              excludeCloseSale,
            });
          }
        }
        if (description === null) {
          this.setState({ createNewEnrollment: true });
          this.onNewFormDataHandler();
        }
      });
  };

  onNewFormDataHandler = () => {
    const { dealerNo } = this.state;
    if (dealerNo) {
      client
        .query({
          query: dealerInformationQuery,
          variables: { dealerNumber: dealerNo },
        })
        .then(({ data }) => {
          const dealerName = get(data, 'dealerInformation.dealerName');
          this.setState({
            dealername: dealerName,
            dealerNumber: dealerNo,
          });
        });
    }
  };

  onFlatRateHandler = product => event => {
    const flatRateValue = event.target.value;
    this.setState({ flatrate1: flatRateValue, lpiprice1: 0 });
    if (product === 'sevenDayFlatPSI' && parseInt(flatRateValue, 10) > 0) {
      this.setState({ lpiprice1: parseInt(flatRateValue, 10) + 20 });
    }
    if (product === 'fourteenDayFlatPSI' && parseInt(flatRateValue, 10) > 0) {
      const finalLpiPrice = parseInt(flatRateValue, 10) - 10;
      this.setState({ lpiprice1: finalLpiPrice > 0 ? finalLpiPrice : 0 });
    }
  };

  onChangeHandler = field => event => {
    this.setState(prevState => ({
      ...prevState,
      [field]: event.target.value,
      errors: { ...prevState.errors, [field]: undefined },
    }));
  };

  render() {
    const { onSubmitHandler } = this.props;
    const {
      data: { locations },
    } = this.props;

    const manheimlocations = locations.filter(
      item => item.partnerNetwork === 'US-Manheim'
    );

    const {
      errors,
      dealerNo,
      dealername,
      contactname,
      contactemail,
      contactphone,
      product1,
      product2,
      cascade,
      flatrate1,
      purchaseChannel1,
      location1,
      location2,
      lpiprice1,
      psimileage1,
      startDate1,
      startDate2,
      searched,
      description,
      modify,
      cancel,
      createNewEnrollment,
      excludeCloseSale,
    } = this.state;

    let allLocationsOption = [];

    if (
      location1.includes('*')
      || location2.includes('*')
    ) {
      allLocationsOption = [
        {
          text: 'All locations',
          key: 0,
          value: '*',
          disabled: true,
        },
      ];
    } else {
      allLocationsOption = [
        {
          text: 'All locations',
          key: 0,
          value: '*',
          disabled: false,
        },
      ];
    }

    let locationOptions = [];
    if (
      product1 !== 'sevenDayFlatPSI'
      && product1 !== 'fourteenDayFlatPSI'
    ) {
      locationOptions = !isEmpty(manheimlocations)
        && manheimlocations.map(location => {
          return {
            text: location.name,
            key: location.id,
            value: location.initials,
          };
        });
    } else {
      locationOptions = [];
    }

    const allLocations = [...allLocationsOption, ...locationOptions];
    const totalLocations = [...new Set(allLocations)];

    const requestTypeOptions = [
      { key: 1, text: 'New', value: 'New' },
      { key: 2, text: 'Modify', value: 'Modify' },
      { key: 3, text: 'Cancel', value: 'Cancel' },
    ];

    const productOptions = [
      { key: 1, text: 'Auto PSI 7 Day', value: 'sevenDayVarPSI' },
      { key: 2, text: 'Auto PSI 14 Day', value: 'fourteenDayVarPSI' },
      {
        key: 3,
        text: 'Flat Rate Auto PSI 7 Day',
        value: 'sevenDayFlatPSI',
      },
      {
        key: 4,
        text: 'Flat Rate Auto PSI 14 Day',
        value: 'fourteenDayFlatPSI',
      },
    ];

    const product2Options = [
      { key: 1, text: 'Auto PSI 7 Day', value: 'sevenDayVarPSI' },
      { key: 2, text: 'Auto PSI 14 Day', value: 'fourteenDayVarPSI' },
    ];

    const product2OptionForAuto7 = [
      { key: 1, text: 'Select Product', value: null },
      { key: 2, text: 'Auto PSI 14 Day', value: 'fourteenDayVarPSI' },
    ];

    const product2OptionForAuto14 = [
      { key: 1, text: 'Select Product', value: null },
      { key: 2, text: 'Auto PSI 7 Day', value: 'sevenDayVarPSI' },
    ];

    const cascadeOptions = [
      { key: 1, text: 'Yes', value: true },
      { key: 2, text: 'No', value: false },
    ];

    const excludeFactoryOptions = [
      { key: 1, text: 'True', value: true },
      { key: 2, text: 'False', value: false },
    ];

    const psiVehicleMilesOptions = [
      { key: 1, text: '0-36000', value: '36000' },
      { key: 2, text: 'Custom Mileage', value: 'custom' },
    ];

    const purchaseChannelOptions = [
      { key: 1, text: 'In-lane', value: 'In-Lane' },
      { key: 2, text: 'Simulcast', value: 'Simulcast' },
    ];

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
      if (
        (field === 'product1' || field === 'product2')
        && (data.value !== 'sevenDayFlatPSI'
          || data.value !== 'fourteenDayFlatPSI')
      ) {
        this.setState({ lpiprice1: 0, flatrate1: 0 });
      }
      if (
        (field === 'location1' && data.value.includes('*'))
        || (field === 'location2' && data.value.includes('*'))
      ) {
        this.setState({ [field]: '*' });
      }
      if (
        field === 'product1'
        && (data.value === 'sevenDayFlatPSI'
          || data.value === 'fourteenDayFlatPSI')
      ) {
        this.setState({ purchaseChannel1: ['In-Lane', 'Simulcast'] });
      }
    };

    const product1Value = product1;
    const cascadeValue = cascade;

    const product2Value = product2;

    const onDateChangeHandler = field => newDate => {
      this.setState({ [field]: moment(newDate, 'YYYY-MM-DD') });
    };

    const date = isEmpty(startDate1)
      ? null
      : utcMoment(startDate1);

    const validationRules = {
      dealerNo: 'required',
      contactemail: 'required|email',
      contactphone: 'required|telephone',
      psimileage1: 'customMileage',
      dealerNumber: 'required',
      dealername: 'required',
      contactname: 'required',
      purchaseChannel1: 'required',
      location1: 'required',
    };

    Validator.register(
      'telephone',
      value => {
        // requirement parameter defaults to null
        return value.match(/[^\d{3}]\d{3}-\d{4}$/);
      },
      'The :attribute phone number is not in the format (XXX)XXX-XXXX.'
    );

    Validator.register(
      'customMileage',
      value => {
        return value > 0 && value < 124999;
      },
      'Mileage should be between 0 – 124,999.'
    );

    const cancelForm = () => {
      this.setState({
        dealerNumber: '',
        requestType: null,
        dealername: '',
        contactname: '',
        contactemail: '',
        contactphone: '',
        product1: null,
        product2: null,
        flatrate1: null,
        purchaseChannel1: null,
        location1: [],
        location2: [],
        psimileage1: '',
        lpiprice1: null,
        startDate1: null,
        startDate2: null,
        excludeCloseSale: false,
        openReviewModal: false,
        showAdditionalPriceMessage: false,
        showflatrate1PriceField: false,
        errors: {},
        modify: false,
        cancel: false,
        dealerNo: '',
        searched: false,
        description: null,
        cascade: false,
      });
      return null;
    };

    const submitForm = () => {
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState(prevState => ({ ...prevState, ...validation.errors }));
        return false;
      }
      onSubmitHandler({
        ...this.state,
        totalLocations,
        requestTypeOptions,
        productOptions,
        product2Options,
        cascadeOptions,
        excludeFactoryOptions,
        psiVehicleMilesOptions,
        purchaseChannelOptions,
        product2OptionForAuto7,
        product2OptionForAuto14,
        openReviewModal: !modify,
        lpiprice1: cascade ? lpiprice1 : 0,
        psiprice1: isEmpty(flatrate1) ? 0 : flatrate1,
        startDate2:
            isEmpty(startDate2) && createNewEnrollment
              ? startDate1
              : startDate2,
        product1:
            product2 === 'sevenDayFlatPSI'
            || product2 === 'fourteenDayFlatPSI'
              ? null
              : product1,
        product2:
            product1 === 'sevenDayFlatPSI'
            || product1 === 'fourteenDayFlatPSI'
              ? null
              : product2,
        cancelForm,
      });
      this.setState(prevState => ({ ...prevState, ...validation.errors }));
      return true;
    };

    return (
      <div>
        <Segment placeholder='true'>
          <Form>
            <Form.Group widths='two'>
              <Form.Input
                name='dealerNo'
                placeholder='5M'
                value={dealerNo}
                onChange={this.onChangeHandler('dealerNo')}
              />
              <Form.Button
                color='green'
                onClick={() => {
                  this.onSearchSubmitHandler();
                }}
                inverted
              >
                Search
              </Form.Button>
            </Form.Group>

            {searched === false && (
              <Message negative>
                <p>
                  Please enter a DEALER NUMBER and press the SEARCH button to
                  proceed
                </p>
              </Message>
            )}

            {searched === true
              && description === null && (
                <Message negative>
                  <p>
                    Dealer {dealerNo} does not have a PSI product
                    subscription
                  </p>
                </Message>
            )}

            {description !== null && (
              <Message positive>
                <p>
                  Dealer {dealerNo} has a PSI product Subscription
                </p>
              </Message>
            )}
            <Header>
              On the AutoPSI form below, please fill out the required
              information(*).
            </Header>
            <div>
              <Table
                celled
                selectable
                padded
                size='large'
                compact='very'
                style={{ fontSize: '90%' }}
                striped
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell />
                    <Table.HeaderCell />
                    <Table.HeaderCell />
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {searched === true
                    && description === null && (
                      <Table.Row>
                        <Table.Cell>Request Type:</Table.Cell>
                        <Table.Cell>
                          <Select
                            options={requestTypeOptions}
                            name='requestType'
                            onChange={onSelectHandler('requestType')}
                            value='New'
                            disabled
                          />
                        </Table.Cell>
                        <Table.Cell />
                      </Table.Row>
                  )}
                  <Table.Row>
                    <Table.Cell>Dealer #</Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder='Enter Dealer No:'
                        name='dealerNumber'
                        value={dealerNo}
                        onChange={this.onChangeHandler('dealerNumber')}
                        disabled
                      />
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Dealership Name</Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder='Enter Dealer Name:'
                        name='dealername'
                        value={dealername}
                        onChange={this.onChangeHandler('dealername')}
                        disabled
                      />
                      {errors.dealername && (
                        <span style={{ color: 'red' }}>
                          Dealer name not found in tappy database
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Contact Name
                      <span style={{ color: 'red' }}>{' * '}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder='Enter Contact Name:'
                        name='contactname'
                        value={contactname}
                        onChange={this.onChangeHandler('contactname')}
                        disabled={!createNewEnrollment}
                      />
                      {errors.contactname && (
                        <span style={{ color: 'red' }}>
                          Contact name is mandatory
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Contact Email
                      <span style={{ color: 'red' }}>{' * '}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder='Enter Contact Email:'
                        name='contactemail'
                        value={contactemail}
                        onChange={this.onChangeHandler('contactemail')}
                        disabled={!createNewEnrollment}
                      />
                      {errors.contactemail && (
                        <span style={{ color: 'red' }}>
                          {errors.contactemail}
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Contact Phone #
                      <span style={{ color: 'red' }}>{' * '}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <NumericFormat
                        format='(###) ###-####'
                        mask='_'
                        value={contactphone}
                        onChange={this.onChangeHandler('contactphone')}
                        disabled={!createNewEnrollment}
                      />
                      {errors.contactphone && (
                        <span style={{ color: 'red' }}>
                          {errors.contactphone}
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Product1</Table.Cell>
                    <Table.Cell>
                      <Select
                        placeholder='Select Product'
                        options={productOptions}
                        name='product1'
                        onChange={onSelectHandler('product1')}
                        value={product1}
                        className='product-type-selector'
                        disabled={!createNewEnrollment}
                      />
                    </Table.Cell>
                    {(product1Value === 'sevenDayFlatPSI'
                      || product1Value === 'fourteenDayFlatPSI') && (
                      <Table.Cell>
                        Enter Flat Rate Price:
                        <Input
                          placeholder='Enter Flat Rate Price:'
                          name='flatrate1'
                          value={flatrate1}
                          onChange={this.onFlatRateHandler(product1)}
                          disabled={!createNewEnrollment}
                        />
                      </Table.Cell>
                    )}
                    {!(
                      product1Value === 'sevenDayFlatPSI'
                      || product1Value === 'fourteenDayFlatPSI'
                    ) && <Table.Cell />}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Auction Location 1:
                      <span style={{ color: 'red' }}>{' * '}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <Select
                        options={totalLocations}
                        name='location1'
                        onChange={onSelectHandler('location1')}
                        value={location1}
                        multiple
                        selection
                        disabled={!createNewEnrollment}
                      />
                      {errors.location1 && (
                        <span style={{ color: 'red' }}>
                          Location is mandatory
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  {product1Value !== 'sevenDayFlatPSI'
                    && product1Value !== 'fourteenDayFlatPSI' && (
                      <Table.Row>
                        <Table.Cell>Product2</Table.Cell>
                        {product1Value === 'fourteenDayVarPSI' && (
                          <Table.Cell>
                            <Select
                              placeholder='Select Product'
                              options={product2OptionForAuto14}
                              name='product2'
                              onChange={onSelectHandler('product2')}
                              value={product2}
                              className='product-type-selector'
                              disabled={!createNewEnrollment}
                            />
                          </Table.Cell>
                        )}
                        {product1Value === 'sevenDayVarPSI' && (
                          <Table.Cell>
                            <Select
                              placeholder='Select Product'
                              options={product2OptionForAuto7}
                              name='product2'
                              onChange={onSelectHandler('product2')}
                              value={product2}
                              className='product-type-selector'
                              disabled={!createNewEnrollment}
                            />
                          </Table.Cell>
                        )}
                        <Table.Cell>
                          {(product1Value === 'sevenDayFlatPSI'
                            || product1Value === 'fourteenDayFlatPSI') && (
                            <Select
                              placeholder='Select Product'
                              options={product2Options}
                              name='product2'
                              onChange={onSelectHandler('product2')}
                              value={product2}
                              className='product-type-selector'
                              disabled={!createNewEnrollment}
                            />
                          )}
                        </Table.Cell>
                        {!(
                          product2Value === 'sevenDayFlatPSI'
                          || product2Value === 'fourteenDayFlatPSI'
                        ) && <Table.Cell />}
                      </Table.Row>
                  )}
                  {product1Value !== 'sevenDayFlatPSI'
                    && product1Value !== 'fourteenDayFlatPSI' && (
                      <Table.Row>
                        <Table.Cell>Auction Location 2:</Table.Cell>
                        <Table.Cell>
                          <Select
                            options={totalLocations}
                            name='location2'
                            onChange={onSelectHandler('location2')}
                            value={location2}
                            multiple
                            selection
                            disabled={!createNewEnrollment}
                          />
                        </Table.Cell>
                        <Table.Cell />
                      </Table.Row>
                  )}
                  <Table.Row>
                    <Table.Cell>
                      <Header>
                        {' '}
                        The following selections will be applied to all
                        products:
                      </Header>
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Purchase Channel:
                      <span style={{ color: 'red' }}>{' * '}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <Select
                        placeholder='Select Purchase Channel'
                        options={purchaseChannelOptions}
                        name='purchaseChannel1'
                        onChange={onSelectHandler('purchaseChannel1')}
                        value={purchaseChannel1}
                        multiple
                        selection
                        disabled={
                          !createNewEnrollment
                          || product1Value === 'sevenDayFlatPSI'
                          || product1Value === 'fourteenDayFlatPSI'
                        }
                      />
                      {errors.purchaseChannel1 && (
                        <span style={{ color: 'red' }}>
                          Purchase Channel is mandatory
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Exclude Factory</Table.Cell>
                    <Table.Cell>
                      <Select
                        options={excludeFactoryOptions}
                        name='excludeCloseSale'
                        onChange={onSelectHandler('excludeCloseSale')}
                        value={excludeCloseSale}
                        disabled={!createNewEnrollment}
                      />
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Cascade To LPI</Table.Cell>
                    <Table.Cell>
                      <Select
                        placeholder='Select Option'
                        options={cascadeOptions}
                        name='cascade'
                        onChange={onSelectHandler('cascade')}
                        value={cascade}
                        disabled={!createNewEnrollment}
                      />
                    </Table.Cell>
                    {cascadeValue === true
                      && product1Value === 'sevenDayFlatPSI' && (
                        <Table.Cell>
                          <div>
                            Enter LPI Price:
                            <Input
                              placeholder='Enter LPI Price:'
                              name='lpiPrice1'
                              value={lpiprice1}
                              onChange={this.onChangeHandler('lpiprice1')}
                              disabled={!createNewEnrollment}
                            />
                            <Message>
                              (LPI will be ordered at the 7-day PSI price plus
                              $20)
                            </Message>
                          </div>
                        </Table.Cell>
                    )}
                    {cascadeValue === true
                      && product1Value === 'fourteenDayFlatPSI' && (
                        <Table.Cell>
                          <div>
                            <Input
                              placeholder='Enter LPI Price:'
                              name='lpiPrice1'
                              value={lpiprice1}
                              onChange={this.onChangeHandler('lpiprice1')}
                              disabled={!createNewEnrollment}
                            />
                            <Message>
                              (LPI will be ordered at the 14-day PSI price minus
                              $10 *NOTE: LPI is only a 7 day Guarantee)
                            </Message>
                          </div>
                        </Table.Cell>
                    )}
                    {!(
                      cascadeValue === true
                      && (product1Value === 'sevenDayFlatPSI'
                        || product1Value === 'fourteenDayFlatPSI')
                    ) && <Table.Cell />}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>PSI Vehicle miles:</Table.Cell>
                    <Table.Cell>
                      <Select
                        placeholder='Enter vehicle miles:'
                        name='psimileage'
                        options={psiVehicleMilesOptions}
                        value='custom'
                        onChange={this.onChangeHandler('psimileage')}
                        disabled
                      />
                      {errors.psimileage1 && (
                        <span style={{ color: 'red' }}>
                          {errors.psimileage1}
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder='Enter Custom Mileage:'
                        name='psimileage1'
                        value={psimileage1}
                        onChange={this.onChangeHandler('psimileage1')}
                        disabled={!createNewEnrollment}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Select AutoPSI Start Date1: </Table.Cell>
                    <Table.Cell>
                      <DatePicker
                        style={{ padding: '0', width: '100%' }}
                        selected={date}
                        minDate={new Date()}
                        onChange={onDateChangeHandler('startDate1')}
                        dateFormat='YYYY-MM-DD'
                        disabled={!createNewEnrollment}
                      />
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
            <br />
            {searched === true
              && description !== null && (
                <p>
                  What would you like to do?
                  <br />
                  <Checkbox
                    radio
                    label='Modify'
                    name='checkboxRadioGroup'
                    value='modify'
                    checked={modify}
                    onChange={this.handleCheckBoxChange('modify', 'cancel')}
                  />
                  <br />
                  <Checkbox
                    radio
                    label='Cancel'
                    name='checkboxRadioGroup'
                    value='cancel'
                    checked={cancel}
                    onChange={this.handleCheckBoxChange('cancel', 'modify')}
                  />
                  <br />
                </p>
            )}
            {(modify === true
              || cancel === true
              || createNewEnrollment === true) && (
              <p>
                <Button color='green' inverted onClick={submitForm}>
                  <Icon name='checkmark' /> Continue
                </Button>
                <Button color='green' inverted onClick={cancelForm}>
                  <Icon name='checkmark' /> Cancel
                </Button>
              </p>
            )}
          </Form>
        </Segment>
      </div>
    );
  }
}

AutoPsiForm.propTypes = {
  onSubmitHandler: PropTypes.func,
  data: PropTypes.shape({
    locations: PropTypes.array,
  }),
};

export default compose(
  withRouter,
  graphql(auctionLocationsQuery, 'auctionLocations'),
  LoadingDataEnhancer
)(AutoPsiForm);
